/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's copyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from 'react';
import { cn } from '@/shared/ui/utils/tailwind';

export type ContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'fluid';
  className?: string;
};

/**
 * Container component with Tailwind styling.
 * Replaces Mantine Container.
 *
 * @deprecated Prefer using `<div className="container mx-auto px-4">` directly.
 * @param {ContainerProps} props - Component properties.
 * @returns {JSX.Element} Rendered container.
 */
export const Container: React.FC<ContainerProps> = ({
  size = 'md',
  className,
  children,
  ...props
}) => {
  const sizeClasses = {
    xs: 'max-w-xs',
    sm: 'max-w-sm',
    md: 'max-w-[var(--container-max-width)]',
    lg: 'max-w-6xl',
    xl: 'max-w-7xl',
    fluid: 'max-w-full',
  };

  return (
    <div
      className={cn(
        'mx-auto px-[var(--container-padding)]',
        sizeClasses[size],
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export default Container;
